import React, { useEffect, useState, useCallback } from 'react';
import * as yup from 'yup';
import { useFormik } from 'formik';
import {
  TextField,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Grid,
  Typography,
  CircularProgress,
} from '@material-ui/core';

import { useStyles, Form } from './styles';
import { useAuth } from '../../../../hooks/auth';
import { IOpenMaps, useOpenMaps } from '../../hooks/openmaps';

import { Button } from '../../../../components/Button';

interface IProps {
  open: boolean;
  onClose: () => void;
}

export const OpenMaps: React.FC<IProps> = (props) => {
  const classes = useStyles();
  const {
    data: { user },
  } = useAuth();
  const { loadOpenMaps, saveOpenMaps } = useOpenMaps();
  const [loadingButton, setLoadingButton] = useState(false);
  const [loadingOpenMaps, setLoadingOpenMaps] = useState(true);
  const [data, setData] = useState<IOpenMaps>({
    apiKey: '',
  });

  useEffect(() => {
    async function loadIntegration(): Promise<void> {
      try {
        const response = await loadOpenMaps(user.companyDocument);

        if (!response) return;

        setData({
          ...response,
        });
      } catch (error) {
        console.log(error);
      } finally {
        setLoadingOpenMaps(false);
      }
    }
    if (props.open) loadIntegration();
  }, [loadOpenMaps, props.open, user.companyDocument]);

  const validationSchema = yup.object().shape({
    apiKey: yup.string(),
    days: yup.number(),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      ...data,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setLoadingButton(true);

      try {
        await saveOpenMaps(values);
        props.onClose();
      } catch (error) {
        console.log(error);
      }

      setLoadingButton(false);
    },
  });

  const handleClose = useCallback(() => {
    props.onClose();
    formik.resetForm();
    setLoadingOpenMaps(true);
  }, [props, formik]);

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={props.open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">OPEN STREET MAPS</DialogTitle>
      <DialogContent>
        <Form
          onSubmit={formik.handleSubmit}
          noValidate
          className={classes.form}
        >
          <Grid container spacing={3}>
            {loadingOpenMaps ? (
              <Grid item xs={12}>
                <Typography component="div" align="center">
                  <CircularProgress />
                </Typography>
              </Grid>
            ) : (
              <>
                <Grid item xs={12} sm={12}>
                  <TextField
                    variant="outlined"
                    size="small"
                    required
                    fullWidth
                    label="ApiKey"
                    id="apiKey"
                    name="apiKey"
                    value={formik.values.apiKey}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.apiKey && Boolean(formik.errors.apiKey)
                    }
                    helperText={formik.touched.apiKey && formik.errors.apiKey}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
              </>
            )}
          </Grid>
        </Form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit">
          Fechar
        </Button>

        <Button
          onClick={() => formik.handleSubmit()}
          color="secondary"
          variant="contained"
          loading={loadingButton}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
